var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen",class:{ show: _vm.show }},[_c('div',{staticClass:"loading-icon-container"},[_c('LoadingIcon',{attrs:{"size":"large","colour1":"black","colour2":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }